module.exports = __webpack_public_path__ + "img/7_34.2716c3fd.png";